var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value && _vm.type)?_c('div',[_c('audio',{attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.value,"type":_vm.type}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }